import { UseQueryOptions } from 'react-query';

export interface QueryParams<T> {
  pageNumber?: number;
  pageSize?: number;
  filters?: string;
  sortOrder?: string;
  includeParentOrg?: boolean;
  includeSsoConnection?: boolean;
  options?: UseQueryOptions<T>;
}

export interface OrganizationSettingsDto {
  requiresUserConsent: boolean;
  consentText: string;
  treatmentPlanDisclaimer: string;
  treatmentPlanTemplate: string;
  virtualConferenceInfoPanelEnabled?: boolean;
  virtualConferenceAudioRecording?: boolean;
  autoFillFacilitiesForAccreditation?: boolean;
}

export interface OrganizationDto {
  id: string;
  name: string;
  referenceCode: string;
  parentOrganizationId: string;
  parentOrganization?: OrganizationDto;
  organizationSettings: OrganizationSettingsDto;
  ssoIntegrationStatus: string;
  domains: string[];
  salesForceId: string;
  logoS3Key?: string;
}

export interface OrganizationSettingsForUpdateDto {
  requiresUserConsent: boolean;
  consentText: string;
  disallowPhi: boolean;
  showLabRecommendationsInRecommendationBuilder: boolean;
  treatmentPlanDisclaimer: string;
  treatmentPlanTemplate: string;
  virtualConferenceInfoPanelEnabled: boolean;
  virtualConferenceAudioRecording: boolean;
  autoFillFacilitiesForAccreditation: boolean;
}

export interface OrganizationForUpdateDto {
  name: string;
  referenceCode: string;
  organizationSettings: OrganizationSettingsForUpdateDto;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  salesForceId: string;
  domains: string[];
}

export interface SsoConnectionFileDto {
  fileName?: string;
  certificate?: string;
  isNewFile: boolean;
}

export interface SsoConnectionForManipulationDto {
  file: SsoConnectionFileDto;
  connectionName: string;
  signInUrl?: string;
  signOutUrl?: string;
  enableSignOut: boolean;
  enableIdpInitiation: boolean;
  organizationId: string | undefined;
  domainAliases: string;
}

export interface SsoConnectionDto {
  id: string;
  file: SsoConnectionFileDto;
  connectionName: string;
  signInUrl: string;
  signOutUrl: string;
  enableSignOut: boolean;
  enableIdpInitiation: boolean;
  status: string;
  organizationId: string;
  domainAliases: string;
}

export const Licenses = {
  EmrIntegrations: 'EMR Integrations',
  LabIntegrations: 'Lab Integrations',
  MolecularRecommendations: 'Molecular Recommendations',
  VirtualConference: 'Virtual Conference',
} as const;

export type OrganizationLicenseDto = {
  id: string;
  organizationId: string;
  license: string;
};

export type License = (typeof Licenses)[keyof typeof Licenses];
